import { useState } from 'react';
import { Link } from 'react-router-dom';
import { importFolder } from '../server';
import HeaderButton from './HeaderButton';
import Header from './Header';
import Footer from './Footer';
import Button from './Button';
import Loader from './Loader';

function Import() {

  const [folder, setFolder] = useState("");
  const [msg, setMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (event) => {
    setFolder(event.target.value)
  }

  const handleFolderBrowse = (event) => {
    console.log(folder);
    setIsLoading(true);
    importFolder(folder)
      .then(response => {
        if (response && response.data && response.data.message) {
          console.log(response.data.message)
          setMsg(response.data.message)
        }
      })
      .catch((error) => {
        if (error && error.response && error.response.data && error.response.data.error) {
          console.log(error.response.data.error.message)
          setMsg(error.response.data.error.message)
        }
      })
      .finally(()=> {
        setIsLoading(false);
      })
    event.preventDefault();
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <Header />
      <Link to="/">
                <HeaderButton name={"Home"}/>
            </Link>
      <main className="flex flex-col items-center justify-center flex-1 w-full px-4 relative">
        <form onSubmit={handleFolderBrowse}>
          <p className="text-left p-4 md:p-0 md:text-center md:text-2xl font-bold">Provide the folder path to import videos</p>
          <div className="flex flex-row items-center flex-1 relative">
            <input type="text" onChange={handleChange} />
            <Button  type='submit'>Browse</Button>
          </div>

          {msg && <p>{msg}</p>}
        </form>
      </main>
      {isLoading && <Loader />}
      <Footer />
    </div>
  );
}

export default Import;
